import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import CONFIG from "./config";

const client = new CognitoIdentityProviderClient({ region: CONFIG.region });

export async function signIn(username: string, password: string): Promise<string> {
  const response = await client.send(
    new InitiateAuthCommand({
      ClientId: CONFIG.clientId,
      AuthFlow: "USER_PASSWORD_AUTH",
      AuthParameters: {
        USERNAME: username,
        PASSWORD: password,
      },
    })
  );

  const idToken = response.AuthenticationResult?.IdToken;
  if (!idToken) {
    throw new Error("Sign-in failed: no token received");
  }

  localStorage.setItem("idToken", idToken);
  return idToken;
}

function isExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    // Treat as expired 60s early so we never send a token that dies mid-request
    return typeof payload.exp !== "number" || payload.exp * 1000 < Date.now() + 60_000;
  } catch {
    return true;
  }
}

export function getIdToken(): string | null {
  const token = localStorage.getItem("idToken");
  if (!token || isExpired(token)) {
    localStorage.removeItem("idToken");
    return null;
  }
  return token;
}

export function getUserId(): string | null {
  const token = getIdToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.sub ?? null;
  } catch {
    return null;
  }
}

export function signOut(): void {
  localStorage.removeItem("idToken");
}
